import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, useTheme } from '@mui/material';

import XBigIcon from '@/assets/icons/x-big.svg?react';
import { toTalent } from '@/root/linker';
import TestSession from '@/views/TestSession/TestSession';

const TalentTestSession = () => {
  const params = useParams<{ talentId: string; testSessionId: string }>();
  const navigate = useNavigate();
  const { spacing, palette } = useTheme();

  return (
    <Box
      sx={{ position: 'relative', paddingTop: spacing(5.5), minHeight: '100%', backgroundColor: palette.primary[50] }}
    >
      <Button
        variant="text-icon"
        type="button"
        sx={{
          position: 'absolute',
          color: palette.primary.main,
          insetInlineEnd: spacing(3),
          insetBlockStart: spacing(2)
        }}
        onClick={() => navigate(toTalent({ talentId: params.talentId! }))}
      >
        <XBigIcon width={20} height={20} />
      </Button>
      <TestSession testSessionId={params.testSessionId!} />
    </Box>
  );
};

export default TalentTestSession;
